import { useContext } from 'react'

import { IThemeContext, ThemeContext } from '../contexts/ThemeContext'

export const useTheme = (): IThemeContext => {
  return useContext(ThemeContext)
}
